import { render } from "./NcRadio.vue?vue&type=template&id=06c6cc18&scoped=true"
import script from "./NcRadio.vue?vue&type=script&lang=js"
export * from "./NcRadio.vue?vue&type=script&lang=js"

import "./NcRadio.vue?vue&type=style&index=0&id=06c6cc18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c6cc18"]])

export default __exports__